'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDaihuoPosition = exports.isRumorTitle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-case-declarations */
/* eslint-disable camelcase */
/*
 * @Author: jerryfwang
 * @Date: 2019-09-01 11:55:06
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-08-02 17:31:46
 */


exports.default = buildFieldComponents;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _article2HTML = require('@tencent/article2HTML');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var rumorComponents = null;
var rumorSearcher = null;
var _isRumorTitle = false;
var _daihuoPosition = null;
/**
 * 是否listapp文章的行内元素
 * @param  {String} type
 * @return {Boolean}
 */
function isInlineElement(type) {
  return ['text', 'link', 'strong'].some(function (item) {
    return item === type;
  });
}

/**
 * 计算元素的高宽比
 * @param  {CoolReadContentFieldStruct} item
 * @return {Number}
 */
var getRatio = function getRatio() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ratio = 0;
  if (item.width) {
    ratio = item.height / item.width;
  }
  return ratio;
};
/**
 * 数据转换成前端通用的数据结构
 * @param  {Object} params  jsonData
 * @return {Object}
 */
function convertField(item) {
  switch (item.eCff) {
    case _article2HTML.EContentFieldFlag.ECFF_IMGTEXT:
    case _article2HTML.EContentFieldFlag.ECFF_TEXT:
      return {
        type: 'text',
        value: item.sVal
      };
    case _article2HTML.EContentFieldFlag.ECFF_LINK:
      return {
        type: 'link',
        value: item.sVal
      };
    case _article2HTML.EContentFieldFlag.ECFF_STRONG:
      return {
        type: 'strong',
        value: item.sVal
      };
    case _article2HTML.EContentFieldFlag.ECFF_IMG:
      if (!item.width || !item.height) {
        return;
      }
      return {
        type: 'image',
        src: item.sCdnOriginalImageUrl,
        srcSized: item.sCdnSizedImageUrl,
        srcHD: item.sCdnOriginalImageUrl,
        width: item.width,
        height: item.height,
        ratio: getRatio(item),
        lazy: true,
        extInfo: item.sVal,
        imgExternalData: item.imgExternalData,
        bIsCommerce: item.bIsCommerce // 是否为商品
      };
    case _article2HTML.EContentFieldFlag.ECFF_VIDEO:
      {
        return {
          type: 'video',
          ratio: getRatio(item),
          width: item.width,
          height: item.height,
          vid: item.sVid || item.vid,
          src: item.sVal,
          poster: item.sPoster,
          label: _lodash2.default.get(global.TAF_CONFIG, 'isomorphic.article.video.layer.text')
        };
      }
    case _article2HTML.EContentFieldFlag.ECFF_VIDEO_IFRAME:
      return {
        type: 'video-iframe',
        width: item.width,
        height: item.height,
        ratio: getRatio(item),
        src: item.sVal
      };
    case _article2HTML.EContentFieldFlag.ECFF_BR:
      return {
        type: 'br'
      };
    case _article2HTML.EContentFieldFlag.ECFF_BOOK_INFO:
      return _extends({
        type: 'book'
      }, item.bookInfo || {});
    case _article2HTML.EContentFieldFlag.ECFF_ANCHOR_INFO:
      return _extends({
        type: 'anchor'
      }, item.anchorInfo || {});
    default:
      break;
  }
}
var judgeSpecialContent = function judgeSpecialContent(style) {
  return style && style.key === 'special_content_class' && style.value.indexOf('rumor') > -1;
};

/**
 * 特殊类型处理
 * @param {Object} dataItem
 * @param {String} type
 * @return {Boolean}
 */
function isRumorData(dataItem, type) {
  var isRumor = null;
  var _dataItem$txt_style = dataItem.txt_style,
      txt_style = _dataItem$txt_style === undefined ? [] : _dataItem$txt_style,
      _dataItem$paragraph_s = dataItem.paragraph_style,
      paragraph_style = _dataItem$paragraph_s === undefined ? [] : _dataItem$paragraph_s;

  isRumor = paragraph_style.find(function (style) {
    if (judgeSpecialContent(style)) {
      return style;
    }
    return null;
  });
  if (isRumor) {
    var _isRumor = isRumor,
        _isRumor$value = _isRumor.value,
        value = _isRumor$value === undefined ? '' : _isRumor$value;

    var contentType = value.replace(/rumor-/, '');
    if (type === 'cnt_article') {
      switch (contentType) {
        case 'rumor':
          // 头部流传说法
          rumorComponents.header.value.title = txt_style.map(function (item) {
            return item.txt;
          }).join('');
          break;
        case 'key_points':
          rumorComponents.header.value.keyPoints = rumorComponents.header.value.keyPoints || [];
          var points = txt_style.map(function (item) {
            return item.txt;
          }).join('');
          rumorComponents.header.value.keyPoints.push(points);
          break;
        case 'researcher':
          txt_style.forEach(function (element) {
            var _element$ext = element.ext,
                ext = _element$ext === undefined ? [] : _element$ext,
                txt = element.txt;

            if (ext && txt) {
              var _ext$find = ext.find(function (item) {
                if (judgeSpecialContent(item)) {
                  return item;
                }
                return {};
              }),
                  _ext$find$value = _ext$find.value,
                  v = _ext$find$value === undefined ? '' : _ext$find$value;

              switch (v) {
                case 'rumor-main':
                  rumorSearcher.author = txt;
                  break;
                case 'rumor-sub':
                  rumorSearcher.desc = txt;
                  break;
                default:
                  break;
              }
            }
          });
          rumorComponents.header.value.researcher = rumorSearcher;
          break;
        case 'time':
          rumorSearcher.time = txt_style.map(function (item) {
            return item.txt;
          }).join('');
          rumorComponents.header.value.researcher = rumorSearcher;
          break;
        case 'reference':
          rumorComponents.footer.value.reference = rumorComponents.footer.value.reference || [];
          var reference = txt_style.map(function (item) {
            return item.txt;
          }).join('');
          rumorComponents.footer.value.reference.push(reference);
          break;
        default:
          break;
      }
    } else if (type === 'img_url') {
      switch (contentType) {
        case 'head':
          var _dataItem$imgurl = dataItem.imgurl0,
              imgurl0 = _dataItem$imgurl === undefined ? {} : _dataItem$imgurl;

          rumorSearcher.img = imgurl0.imgurl || '';
          rumorComponents.header.value.researcher = rumorSearcher;
          break;
        default:
          break;
      }
    }
  }
  return isRumor;
}
/**
 * 将内容中心的数据结构转换成统一结构
 * @param  {Array} params  jsonData
 * @return {Object}
 */
function jsonContent2Components(params) {
  _isRumorTitle = false;
  _daihuoPosition = null;
  if (_lodash2.default.isArray(params)) {
    var components = [];
    rumorComponents = { header: { type: 'rumor_header', value: {} }, footer: { type: 'rumor_footer', value: {} } };
    rumorSearcher = { author: '', img: '', time: '', desc: '' };
    params.forEach(function (dataItem) {
      var _ref = dataItem || {},
          _ref$type = _ref.type,
          type = _ref$type === undefined ? '' : _ref$type;
      /* eslint-disable no-case-declarations */
      /* eslint-disable camelcase */
      /* eslint-disable no-param-reassign */
      /* eslint-disable no-invalid-regexp */


      var isSpecial = false;
      switch (type) {
        case 'cnt_article':
          isSpecial = isRumorData(dataItem, 'cnt_article');
          if (!isSpecial) {
            var _dataItem$txt_style2 = dataItem.txt_style,
                txt_style = _dataItem$txt_style2 === undefined ? '' : _dataItem$txt_style2,
                _dataItem$desc = dataItem.desc,
                desc = _dataItem$desc === undefined ? '' : _dataItem$desc,
                _dataItem$paragraph_s2 = dataItem.paragraph_style,
                paragraph_style = _dataItem$paragraph_s2 === undefined ? [] : _dataItem$paragraph_s2,
                _dataItem$sub_type = dataItem.sub_type,
                sub_type = _dataItem$sub_type === undefined ? '' : _dataItem$sub_type;

            var strongArr = null;
            try {
              var reg = new RegExp('(?<=<strong>).*?(?=</strong>)', 'g'); // / ios中引入包编解码有问题 需要class初始化
              strongArr = desc.match(reg);
            } catch (e) {
              /* 避免这里ReExp正则报错 */
            }
            if (txt_style && _lodash2.default.isArray(txt_style)) {
              txt_style.forEach(function (element) {
                var _ref2 = element || {},
                    ext = _ref2.ext;

                var txt = (element || {}).txt;
                if (strongArr && strongArr.indexOf(txt) > -1 || sub_type === 'first_or_second_title') {
                  // 处理粗体的问题
                  ext = (ext || []).concat([{
                    key: 'font-weight', value: 'bold'
                  }]);
                }
                if (paragraph_style.length) {
                  // 处理整体的样式
                  ext = (ext || []).concat(paragraph_style);
                }
                if (ext) {
                  // 去掉整体的字体大小设置
                  ext.forEach(function (el, index) {
                    if (el && (el.key === 'font-size' || el.key === 'line-height')) {
                      // ext.splice(index, 1);
                      if (ext[index] && ext[index].value) {
                        ext[index].value = ext[index].value.replace('pt', 'px'); // 处理pt的问题
                      }
                    }
                  });
                }
                element.ext = ext;
              });
            }
            components.push({
              type: sub_type || 'text',
              value: txt_style
            });
          }
          break;
        case 'img_url':
          isSpecial = isRumorData(dataItem, 'img_url');
          if (!isSpecial) {
            var imgurl640 = dataItem.imgurl640,
                imgurl0 = dataItem.imgurl0,
                imgurlgif = dataItem.imgurlgif,
                _dataItem$size = dataItem.size,
                size = _dataItem$size === undefined ? 0 : _dataItem$size;

            var imageObj = imgurlgif || imgurl640 || imgurl0;

            var _ref3 = imageObj || {},
                width = _ref3.width,
                imgurl = _ref3.imgurl,
                height = _ref3.height;

            components.push({
              type: 'image',
              src: imgurl,
              srcSized: imgurl,
              srcHD: imgurl,
              width: width,
              height: height,
              size: size,
              ratio: getRatio(imageObj),
              lazy: true
            });
          }
          break;
        case 'video':
          var img = dataItem.img,
              img_width = dataItem.img_width,
              img_height = dataItem.img_height,
              title = dataItem.title,
              vid = dataItem.vid,
              src = dataItem.src,
              rest = _objectWithoutProperties(dataItem, ['img', 'img_width', 'img_height', 'title', 'vid', 'src']);

          components.push(_extends({
            type: 'video',
            ratio: getRatio({
              width: img_width,
              height: img_height
            }),
            width: img_width,
            height: img_height,
            vid: vid,
            src: src,
            poster: img,
            label: title
          }, rest));
          break;
        case 'novel':
          components.push(_extends({
            type: 'novel'
          }, dataItem));
          break;
        case 'daihuo':
          if (!_daihuoPosition) {
            _daihuoPosition = _defineProperty({}, dataItem.id, components.length);
          } else {
            _daihuoPosition[dataItem.id] = components.length;
          }
          break;
        case 'music':
          components.push(_extends({
            type: 'music'
          }, dataItem));
          break;
        default:
          break;
      }
    });
    var header = !_lodash2.default.isEmpty(rumorComponents.header.value) ? rumorComponents.header : '';
    if (header) {
      _isRumorTitle = true;
    }
    var footer = !_lodash2.default.isEmpty(rumorComponents.footer.value) ? rumorComponents.footer : '';
    var _components = [header].concat(components).concat([footer]).filter(Boolean);
    return _components;
  }
  return null;
}
var isRumorTitle = exports.isRumorTitle = function isRumorTitle() {
  return _isRumorTitle;
};
var getDaihuoPosition = exports.getDaihuoPosition = function getDaihuoPosition() {
  return _daihuoPosition;
};
/**
 * 生成供 React 组件使用的 props
 * @param  {Array} contentFields     article from ListApp
 * @param  {Object} CCOpts  兼容内容中心配置
 * @param  {Object} searchOpts 正文查询参数
 * @param  {Function} reportFnc 回调上报方法
 * @return {String}
 */
function buildFieldComponents(contentFields) {
  var CCOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var searchOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var reportFnc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  var result = null;
  var monitorReport = reportFnc;
  var _CCOpts$sJsonContent = CCOpts.sJsonContent,
      sJsonContent = _CCOpts$sJsonContent === undefined ? '' : _CCOpts$sJsonContent,
      _CCOpts$bUseHtml = CCOpts.bUseHtml,
      bUseHtml = _CCOpts$bUseHtml === undefined ? false : _CCOpts$bUseHtml,
      _CCOpts$sHtmlContent = CCOpts.sHtmlContent,
      sHtmlContent = _CCOpts$sHtmlContent === undefined ? '' : _CCOpts$sHtmlContent,
      _CCOpts$isHtml = CCOpts.isHtml,
      isHtml = _CCOpts$isHtml === undefined ? false : _CCOpts$isHtml; // bUseHtml, sHtmlContent,

  if (bUseHtml && sHtmlContent && isHtml) {
    monitorReport('HTMLHIT');
    return sHtmlContent;
  } else if (sJsonContent) {
    monitorReport('HAVEJSON');
    try {
      var jsonContent = JSON.parse(sJsonContent) || [];
      // JSON.parse(sJsonContent) || []; // /RumorData.concat(JSON.parse(sJsonContent) || []);
      if (jsonContent && jsonContent.length) {
        result = jsonContent2Components(jsonContent);
        monitorReport('JSONNORMAL');
      }
    } catch (error) {
      console.log('buildFieldByJSONData error', error);
      monitorReport('JSONERROR');
    }
  }
  if (!sJsonContent) {
    monitorReport('NOJSON');
  }
  monitorReport(bUseHtml ? 'USEHTML' : 'NOUSEHTML');
  if (!result) {
    monitorReport('USEOLDMOUDLE');
    result = [];
    var inlineStack = [];
    contentFields.map(convertField).forEach(function (item) {
      if (isInlineElement(item && item.type)) {
        inlineStack.push(item);
      } else {
        if (inlineStack.length) {
          // 整个数组作为一个 item
          // 前端会议 iniline 的方式渲染
          result.push(inlineStack.filter(Boolean));
          inlineStack = []; // reset
        }
        result.push(item);
      }
    });
    if (inlineStack.length) {
      result.push(inlineStack.filter(Boolean));
    }
  }
  return result.filter(Boolean);
}